// extracted by mini-css-extract-plugin
module.exports = {"header":"iRb-d_SbfOm-6hyCyDZSD","connectJustoAccount":"_3exch1uNzZYoaBd42prJRZ","description":"_38VITmrtqxzFv0ty0LteXq"};